import { deleteRequest, postRequest, putRequest } from '../request/request.service';
import {
  ForgetPasswordPayload,
  ForgetPasswordResponse,
  LoginPayload,
  LoginSendCodePayload,
  LoginSendCodeResponse,
  LoginVerifyCodePayload,
  LoginVerifyCodeResponse,
  ResetPasswordPayload,
  SignOutResponse,
  UserLoginResponse,
} from './authentication.service.types';

export async function signIn(data: LoginPayload) {
  return postRequest<UserLoginResponse>('/auth/sign_in', { data }).then((response) => {
    return { user: response };
  });
}

export async function sendCode(data: LoginSendCodePayload) {
  return postRequest<LoginSendCodeResponse>('/auth/send_code', { data }).then((response) => {
    return response;
  });
}

export async function verifyCode(data: LoginVerifyCodePayload) {
  return postRequest<LoginVerifyCodeResponse>('/auth/verify_code', { data }).then((response) => {
    return response;
  });
}

export async function forgetPassword(data: ForgetPasswordPayload) {
  return postRequest<ForgetPasswordResponse>('/auth/password', { data });
}

export async function resetPassword(data: ResetPasswordPayload) {
  return putRequest<UserLoginResponse>('/auth/password', { data }).then((response) => {
    return { user: response };
  });
}

export async function signOut() {
  return deleteRequest<SignOutResponse>('/auth/sign_out');
}
